var map = {
	"./Vector.svg": 1216,
	"./account.svg": 3647,
	"./add-new.svg": 7242,
	"./angle-down.svg": 7454,
	"./arrow-down.svg": 4746,
	"./arrow-right.svg": 153,
	"./arrow-up.svg": 9689,
	"./audio.svg": 2394,
	"./back.svg": 7911,
	"./bookmark.svg": 8619,
	"./button-back.svg": 8876,
	"./cancel.svg": 7373,
	"./easy.svg": 2247,
	"./exclamation.svg": 5978,
	"./hard.svg": 2737,
	"./iconmoi.svg": 5590,
	"./logout-mobile.svg": 5903,
	"./logout.svg": 2990,
	"./magnifier.svg": 372,
	"./menu.svg": 5674,
	"./normal.svg": 2440,
	"./openbook.svg": 3290,
	"./password.svg": 5386,
	"./pencil.svg": 1265,
	"./plus.svg": 3189,
	"./reload.svg": 6939,
	"./save.svg": 3884,
	"./trash.svg": 967,
	"./white-plus.svg": 4492
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;